// extracted by mini-css-extract-plugin
export default {"legend":"Legend_legend__A986-","tagName":"Legend_tagName__tCrzT","tagColor":"Legend_tagColor__fycP5","faded":"Legend_faded__QdDvZ"};